export default __webpack_public_path__ + "media/images/elephant_ui_plane-59b7978cc88cfcc2118d0a0bf62b8bbb.svg";